<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card
        [advanceButton]="true"
        [advancedButtons]="isBackOffice() ? specialButton : []"
        (outputButtonAdvance)="calFunction($event)"
        [title]="'menu.exchange'|translate">
        <app-grid [grid]="grid" (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>

<a #downloadLink href="" download style="display: none"></a>

<app-modal-basic #uploadModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'menu.exchange' | translate}} - {{'global.import' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelUpload()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.import_file' | translate}} (Excel)</p>
    <div class="form-group row">
      <div class="form-group col-md-12">
        <label>{{ 'global.import_file' | translate}} *</label>
        <label class="custom-file">
          <input
            type="file"
            class="custom-file-input"
            (change)="onFileSelected($event)"
            #uploaderFileInput
            id="uploaderFile"
            accept=".xlsx,.xls"
          >
          <span class="custom-file-control-upload"
                *ngIf="!selectedFileName">{{"global.choose_file"|translate}}</span>
          <span class="custom-file-control-upload"
                *ngIf="selectedFileName">{{"global.exchange_file"|translate}}</span>
          <span
            class="custom-file-control">{{selectedFileName}}</span>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="preloader3 loader-block mx-auto" *ngIf="isUploading">
        <div class="circ1 loader-success"></div>
        <div class="circ2 loader-success"></div>
        <div class="circ3 loader-success"></div>
      </div>
    </div>

  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="cancelUpload()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="uploadFile()" [disabled]="isUploading || !selectedFile">{{'global.import'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #importResultModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'menu.exchange' | translate}} - {{'global.import' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="importResultModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <ul style="list-style-type: disc" class="ps-3">
      <li *ngFor="let message of messages" class="import-error-message" [ngClass]="{'text-danger': message.includes('*')}">
        {{ message }}
      </li>
    </ul>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-primary ripple light"
            (click)="importResultModal.hide()">{{'global.ok'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #importSuccessModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'menu.exchange' | translate}} - {{'global.import' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="importSuccessModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <ul class="ps-3 mb-0" style="list-style-type: disc">
      <li *ngFor="let item of importSuccessRows">
        Row {{ item.row }}: {{ item.changedCellsLabel }}
      </li>
    </ul>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-primary ripple light"
            (click)="importSuccessModal.hide()">{{'global.ok'|translate}}</button>
  </div>
</app-modal-basic>

<ng-template #cellEllipsisTooltip let-row="row" let-value="value" let-column="column">
  <ng-container *ngIf="cellDisplay(column, value) as cell">
    <span
      class="exchange-grid-cell-ellipsis"
      [ngbTooltip]="cell.text"
      [disableTooltip]="!cell.showTooltip"
      placement="top"
      container="body"
      tooltipClass="exchange-grid-cell-tooltip"
    >
      {{ cell.text }}
    </span>
  </ng-container>
</ng-template>


<ng-template #orderNoLinkTpl let-row="row" let-value="value" let-column="column">
  <ng-container *ngIf="cellDisplay(column, value) as cell">
    <button
      type="button"
      class="btn btn-link p-0 text-start exchange-grid-cell-ellipsis"
      [ngbTooltip]="cell.text"
      [disableTooltip]="!cell.showTooltip"
      placement="top"
      container="body"
      tooltipClass="exchange-grid-cell-tooltip"
      (click)="goToBackOfficeOrder(row)"
      [disabled]="!(row?.order?.id)"
    >
      {{ cell.text }}
    </button>
  </ng-container>
</ng-template>